import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualAuditLogsPage() {
    return <MarkdownDocPage title="Audit Logs" markdownUrl="/docs/user-manual/pages/audit-logs.md" />;
}

